import type { AuthMode } from '@dynamic-labs-wallet/browser-wallet-client';
import { DynamicWalletClient } from '@dynamic-labs-wallet/browser-wallet-client';

import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types/DynamicClient';
import { CLIENT_SDK_NAME } from '../../apiClient/constants';
import { isCookieEnabled } from '../../projectSettings/isCookieEnabled';
import {
  DEFAULT_WAAS_BASE_API_URL,
  DEFAULT_WAAS_BASE_MPC_RELAY_API_URL,
} from '../constants';

type CreateWaasClientParams = {
  chainName: string;
};

export const createWaasClient = (
  { chainName }: CreateWaasClientParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  return new DynamicWalletClient({
    authMode: (isCookieEnabled(client) ? 'cookie' : 'header') as AuthMode,
    authToken: client.token || '',
    baseApiUrl: (core.apiBaseUrl || DEFAULT_WAAS_BASE_API_URL).replace(
      '/api/v0',
      ''
    ),
    baseMPCRelayApiUrl:
      client.projectSettings?.sdk.waas?.relayUrl ||
      DEFAULT_WAAS_BASE_MPC_RELAY_API_URL,
    chainName,
    environmentId: core.environmentId,
    sdkVersion: `${CLIENT_SDK_NAME}/${core.version}`,
  });
};
